import { useQuery } from "@tanstack/react-query";
import agentsService from "services/admin/AgentsService";

export const useGetAIAgent = (agentID) => {
    return useQuery({
        queryKey: ['ai-agent', agentID],
        queryFn: async () => {
            const { data } = await agentsService.get(agentID);
            return data;
        },
        refetchOnWindowFocus: false,
    });
};